import { Box } from '@mui/material';


export const AltLogoText = () => {
  return (
    <span>
      Story<Box component="span" color="primaryAlt.main">Forge</Box>
    </span>
  );
};